import { AfterViewInit, Component, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';
import { MenuGroup } from '../../dynamic-input-model';
import { NbMenuItem, NbMenuService, NbTabComponent } from '@nebular/theme';
import { EditorService } from '../../services/editor.service';
import { PreviewEditStoreService } from '../../../services/preview-edit-store.service';

@Component({
  selector: 'ngx-navigation-input',
  templateUrl: './navigation-input.component.html',
  styleUrls: ['./navigation-input.component.scss']
})
export class NavigationInputComponent implements OnInit,AfterViewInit{
  @Input() data:any;
  isLoaded = false;
  menuGroups:any;
  defaultMenuTag:string; 
  topLevelMenuTag = "editNavigationMenu";
  activeInputMenuItem:string;
  defaultInputMenuItem:string;
  menuItems:NbMenuItem[];
  inputCells:NodeListOf<Element>;

  constructor(private editorService:EditorService,
    private menuService:NbMenuService,
    private editStoreService:PreviewEditStoreService,
    private renderer2:Renderer2,
    private el:ElementRef<HTMLElement>) { }
  

  ngOnInit(): void {
    this.menuGroups = this.data;
    let topLevelMenu:MenuGroup = this.menuGroups["topLevelMenu"];

    if(topLevelMenu != undefined){
      this.defaultMenuTag = topLevelMenu.menuTag;
      this.defaultInputMenuItem = topLevelMenu.menuItems[0].title;
      this.activeInputMenuItem = this.defaultInputMenuItem;
    }
    this.menuService.onItemClick().subscribe(menuBag =>{
      console.log({menuBag:menuBag});
      let selectedItem = menuBag.item;
      if(selectedItem != undefined){
        //if(selectedItem.parent.title)
        console.log({selectedItem:selectedItem});
        this.activeInputMenuItem = selectedItem.title;
      }
    })
    this.editStoreService.siteHeader$.subscribe(siteHeader => {
      this.menuItems = siteHeader.mainMenuConfig.menuItems;
      if(this.menuItems != undefined){
        this.isLoaded = true;
      }
      //console.log(siteHeader.mainMenuConfig.menuItems);
    })
    
  }

  ngAfterViewInit(): void {
    console.log(this.el.nativeElement);
    let inputContent = this.el.nativeElement.querySelector('.input-content');
    if(inputContent){
      console.log(this.el.nativeElement);
      this.inputCells = inputContent.querySelectorAll('.section-thumbnail.input-cell');
      console.log(this.inputCells);
    }
  }

  toggleItem(selectedItem:any){
    console.log(selectedItem);
    let isSelected:boolean = selectedItem["isSelected"];
    if(isSelected){
      console.log(this.inputCells);
      this.inputCells.forEach(el => {
        if(el.getAttribute("id") === selectedItem["contentId"]){
          el.classList.add('isActive');          
        }else{
          if(el.classList.contains('isActive')){
            el.classList.remove('isActive');
          }
        }
      })
    }
  }
}
